import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { AlertTriangle, ArrowRight, Check, Shield, Lock } from 'lucide-react';
import { trackAddToCart } from '../../hooks/useMetaPixel';
export function FinalCTASection() {
  return <Section background="cream" className="border-t border-brand-gold/20" data-id="element-77">
      <div className="max-w-3xl mx-auto text-center" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-79">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-red-50 text-red-600 rounded-full text-sm font-bold mb-8 border border-red-100" data-id="element-80">
            <AlertTriangle className="h-4 w-4" data-id="element-81" />
            OFERTA ESPECIAL — ACCESO LIMITADO
          </div>

          <div className="text-lg text-brand-charcoal/80 mb-12 space-y-4" data-id="element-82">
            <p data-id="element-83">Este precio no es permanente.</p>
            <p data-id="element-84">
              El precio regular de Cortisol Off es $29.99. Hoy, como parte de
              esta oferta especial, obtienes el sistema completo — manual
              operativo + 3 bonos de ejecución — por solo{' '}
              <span className="font-bold text-brand-charcoal-dark" data-id="element-85">$6.36</span>.
            </p>
            <p data-id="element-86">
              Por el precio de un café con leche obtienes el sistema exacto para
              nunca volver a necesitar ese café para funcionar.
            </p>
            <p className="font-medium text-brand-charcoal-dark" data-id="element-87">
              Pero esta oferta tiene fecha de vencimiento.
            </p>
            <p data-id="element-88">
              Cuando el contador llegue a cero, el precio vuelve a $29.99 y los
              bonos desaparecen.
            </p>
          </div>

          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-xl border border-brand-gold/30 relative overflow-hidden" data-id="element-89">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-brand-gold-dark via-brand-gold to-brand-gold-light" data-id="element-90"></div>

            <h2 className="text-2xl md:text-4xl font-serif font-bold text-brand-charcoal-dark mb-2" data-id="element-91">
              EL BOTÓN MÁS IMPORTANTE QUE VAS A PRESIONAR HOY
            </h2>
            <p className="text-brand-charcoal/50 text-sm mb-8" data-id="element-92">
              (No porque sea dramático. Sino porque en 7 minutos puedes estar
              operando diferente.)
            </p>

            <Button size="lg" className="w-full text-base sm:text-lg mb-6 shadow-xl shadow-brand-gold/20 py-6" onClick={() => {
            trackAddToCart();
            window.open('https://pay.hotmart.com/K104693298R?off=hiid2a6g', '_blank');
          }} data-id="element-93">
              SÍ, QUIERO RECUPERAR MI ENFOQUE AHORA{' '}
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-94" />
            </Button>

            <div className="flex flex-wrap justify-center items-center gap-4 sm:gap-6 text-sm font-medium text-brand-charcoal/70 mb-6" data-id="element-95">
              <div className="flex items-center" data-id="element-96">
                <Check className="h-4 w-4 text-brand-sage mr-1.5" data-id="element-97" />
                Acceso Inmediato
              </div>
              <div className="flex items-center" data-id="element-98">
                <Shield className="h-4 w-4 text-brand-gold-dark mr-1.5" data-id="element-99" />
                Garantía 30 Días
              </div>
              <div className="flex items-center" data-id="element-100">
                <Lock className="h-4 w-4 text-brand-charcoal/50 mr-1.5" data-id="element-101" />
                Pago 100% Seguro
              </div>
            </div>

            

            <p className="text-brand-charcoal-dark font-serif italic text-lg" data-id="element-102">
              ¿Tu cerebro te está diciendo "después"?
              <br data-id="element-103" />
              <span className="font-bold" data-id="element-104">
                Eso es exactamente el cortisol hablando.
              </span>
              <br data-id="element-105" />
              Haz clic ahora.
            </p>
          </div>
        </motion.div>
      </div>
    </Section>;
}